import * as React from "react";
import { singleton } from "logic/singleton";
const EntityTableMetaDataContext = React.createContext(void 0);
export default singleton("contexts.EntityTableMetaDataContext", () => EntityTableMetaDataContext);
